import { Injectable } from '@angular/core';
import { GenericResponse } from '../generic-response';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { baseUrl } from 'src/app/global-variables';
import { DiseaseModel, DiseasesModel } from 'src/app/core/model/disease-model';
import { UserDataService } from '../user-repository/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class DiseaseService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService
  ) {}

  getDiseasesServer(): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<DiseaseModel[]>(baseUrl + 'api/v2/food/disease', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        if (res) {
          this.saveDiseases(res);
          response = new GenericResponse(true);
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        response = new GenericResponse(false);
        return response;
      });
  }

  prepare(res: DiseaseModel[]): DiseasesModel {
    return new DiseasesModel(res);
  }

  saveDiseases(res: DiseaseModel[]) {
    localStorage.setItem('diseases', JSON.stringify(this.prepare(res)));
  }

  getDiseases(): Promise<DiseasesModel> {
    const dJson = localStorage.getItem('diseases');
    const diseases = DiseasesModel.fromJSON(dJson);
    if (diseases) {
      return Promise.resolve(diseases);
    }
  }

  getDiseasesIds(names: string[]) {
    let ids = [];
    const dJson = localStorage.getItem('diseases');
    const diseases = DiseasesModel.fromJSON(dJson);
    if (diseases) {
      diseases.diseases.forEach((disease) => {
        if (names.includes(disease.name)) {
          ids.push(disease.id);
        }
      });
      return ids;
    }
  }

  getDiseaseNamesByIds(ids: string[]): Promise<string[]> {
    let names: string[] = [];
    if (localStorage.getItem('diseases')) {
      const dJson = localStorage.getItem('diseases');
      const diseases = DiseasesModel.fromJSON(dJson);
      if (diseases) {
        diseases.diseases.forEach((disease) => {
          if (ids.includes(disease.id)) {
            names.push(disease.name);
          }
        });
        return Promise.resolve(names);
      }
    } else {
      return this.getDiseasesServer().then((res) => {
        if (res.isSuccess()) {
          const dJson = localStorage.getItem('diseases');
          const diseases = DiseasesModel.fromJSON(dJson);
          if (diseases) {
            diseases.diseases.forEach((disease) => {
              if (ids.includes(disease.id)) {
                names.push(disease.name);
              }
            });
            return Promise.resolve(names);
          }
        }
      });
    }
  }
}
